import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { useStore } from '../../store';
import { useCreateFullPageSnapShot } from './useCreateFullPageSnapShot';

export interface UploadGenericFileProps {
  fileUsageType: string;
  imageName?: string;
  dataFileName?: string;
}

export const useUploadGenericFile = () => {
  const { currUser } = useStore.getState();
  const { takeScreenShot } = useCreateFullPageSnapShot();
  return useMutation('useUploadGenericFile', async (props: UploadGenericFileProps) => {
    const formData = new FormData();

    const cb = async (imageString: string) => {
      if (imageString) {
        const imageBlob = await fetch(imageString).then((res) => res.blob());

        const dataBlob = new Blob([
          JSON.stringify({
            fileUsageType: props.fileUsageType,
            fileName: props.dataFileName,
          }),
        ]);

        formData.append('data', dataBlob);
        formData.append('image', imageBlob, props.imageName || '');
        await httpService.post(`${BASE_URL}/api/v1/user/${currUser().customerId}/uploadImageFile`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
    };
    await takeScreenShot({ cbOnComplete: cb });
  });
};
